module.exports = __webpack_public_path__ + "images/ec052c565c7d9c4b58cb66dae3c8e9ad66777df513a7fe89b4606f067b5b9c42.svg";